<template>
  <section class="apply-alter">
    <template v-if="detail.orderid">
      <div class="buy-select">
        <ul>
          <li @click="showPaymentMenu = true" v-if="detail.last_change_num < 1" v-cbs="`购买修改次数-点击`">
            <div class="content">购买修改次数</div>
            <div class="go-right">￥{{ detail.change_price }}/次</div>
          </li>
          <li @click="openHistory" v-cbs="`查看记录-点击`">
            <div class="content">查看提交记录</div>
            <div class="go-right"></div>
          </li>
        </ul>
      </div>
      <div class="sign-area" v-if="detail.work_done_url">
        <div class="sign-title">对想要修改的地方进行标记</div>

        <div class="sign-player">
          <mall-player theme="after" ref="player" @set-tag="setTag" :src="detail.work_done_url" />
        </div>

        <div class="sign-btn" @click="getTag" v-cbs="{ name: '标记备注弹窗-展示', product_id: detail.product_info.id }">标记</div>
        <div class="sign-tips">*标记后添加修改备注</div>

        <div class="sign-info" @click="editTag(index)" v-for="(item, index) in againData" :key="index">
          <div class="sign-time">{{ item.time }}</div>
          <div class="sign-des">{{ item.detail | joinAgain }}</div>
          <div class="sign-close" @click.stop="removeTag(index)">
            <img src="~@cdn_img/icon-close.png">
          </div>
          <div class="arrow-right"></div>
        </div>
      </div>
      <div class="remarks-area">
        <div class="remarks-title">其他备注</div>
        <div class="text-area">
          <textarea maxlength="400" v-model.trim="otherNote"></textarea>
          <div class="word-num">{{ wordCount }}/400</div>
        </div>
      </div>
      <div class="tips">*清晰准确的描述可以让制作师更了解你想要的效果</div>
      <div class="commit-area">
        <div class="inner">
          <div class="surplus-times">剩余修改次数<strong>{{ detail.last_change_num }}次</strong></div>
          <button type="button" class="commit-btn" @click="save" v-if="detail.last_change_num > 0">提交订单</button>
        </div>
      </div>

      <van-popup v-model="popupAgain" closeable round position="bottom" close-icon="close" :style="{ height: '80%' }" @close="closePopupAgain">
        <div class="mall-dialog">
          <div class="mall-dialog-body">
            <dl v-if="note.again">
              <template v-for="(item, index) in note.again">
                <dt :key="`dt-${index}`">{{ item.name }}</dt>
                <dd :key="`dd-${index}`">
                  <mall-radio :name="`note-${item.id}`" :value="value" v-model="noteData[item.id]" v-for="(value, valueIndex) in item.detail" :key="valueIndex" v-cbs.change="{ name: `标记备注弹窗-${value.name}`, product_id: detail.product_info.id }">{{ value.name }}</mall-radio>
                </dd>
              </template>
            </dl>
          </div>
          <div class="mall-dialog-footer">
            <button type="button" class="mall-dialog-button" @click="saveAgain" v-cbs="{ name: '标记备注弹窗-确认', product_id: detail.product_info.id }">确认</button>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="popupHistory" closeable round position="bottom" close-icon="close" :style="{ height: '80%' }" @close="popupHistory = false">
        <div class="mall-dialog history">
          <div class="mall-dialog-header">提交记录</div>
          <div class="mall-dialog-body">
            <ul class="history-list">
              <li v-for="(item, index) in history" :key="index">
                <div class="history-time">{{ item.create_time }}</div>
                <div class="history-detail">
                  <template v-if="item.type === 0">
                    <p v-for="(v, i) in item.detail" :key="i">{{ v }}</p>
                  </template>
                  <template v-else-if="item.type === 1">
                    <div class="history-dot" v-for="(value, valueIndex) in item.dot_desc" :key="valueIndex">
                      <p><strong>{{ value.dot_time }}</strong></p>
                      <p v-for="(v, i) in value.detail" :key="i">{{ v }}</p>
                    </div>
                  </template>
                  <div class="remark" v-if="item.other_desc">
                    <p><strong>备注：</strong></p>
                    <p>{{ item.other_desc }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </van-popup>

      <van-action-sheet v-model="showPaymentMenu" :actions="paymentList" cancel-text="取消" title="请选择支付方式" @select="gotoPayment" />
    </template>
  </section>
</template>

<script>
import { trackElClickH5 } from '@changba/funny';
import MallPlayer from '../components/Player';
import MallRadio from '../components/Radio';
import { isHarmonyOS } from '../utils';

export default {
  name: 'ApplyAlter',

  components: {
    MallRadio,
    MallPlayer
  },

  filters: {
    joinAgain(value) {
      const values = Object.values(value);

      return values.map((item) => item.name).join(' | ');
    }
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      detail: {},

      popupAgain: false,
      note: {},
      noteData: {},
      otherNote: '',

      popupHistory: false,
      history: [],

      againData: [],
      currentAgainIndex: -1,
      currentAgainTime: '',

      showPaymentMenu: false,
      // 鸿蒙不显示微信支付
      paymentList: isHarmonyOS() ? [{ name: '支付宝', type: 'alipay' }] : [
        { name: '微信', type: 'wechat' },
        { name: '支付宝', type: 'alipay' }
      ]
    }
  },

  computed: {
    wordCount() {
      return this.otherNote.length;
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch('/api/musicService/musicmall/getOrderInfo', {
        data: {
          orderid: this.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.detail = data;

        if (this.detail.last_change_num < 1) {
          trackElClickH5('购买修改次数-展示');
        }
      }
      else {
        this.$toast.fail(msg);
      }
    },

    async getNote() {
      if (this.note.again) {
        return;
      }

      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getAgainSuggestion', {
        data: {
          productType: this.detail.product_info.type,
          productid: this.detail.product_info.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.note = data;
      }
    },

    async getHistory() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getSubmitNote', {
        data: {
          orderid: this.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.history = data;
      }
    },

    setTag(time) {
      this.currentAgainTime = time;
      this.noteData = {};
      this.currentAgainIndex = -1;
      this.popupAgain = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      this.$nextTick(() => {
        this.getNote();
      });
    },

    getTag() {
      this.$refs.player.$emit('get-tag')
    },

    gotoPayment(item) {
      this.payOther(item.type);
      this.showPaymentMenu = false;
    },

    async payOther(paymentType) {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch('/api/musicService/musicmall/payOther', {
        method: 'post',
        data: {
          orderid: this.id,
          paytype: paymentType,
          service: 'again',
          money: this.detail.change_price
        }
      });

      this.$toast.clear();

      if (code === 1) {
        // this.$dialog.alert({
        //   message: JSON.stringify(data)
        // });
        window.location.href = data;
      }
      else {
        this.$toast.fail(msg);
      }
    },

    saveAgain() {
      const data = {
        time: this.currentAgainTime,
        detail: this.noteData
      };

      if (this.currentAgainIndex >= 0) {
        this.againData[this.currentAgainIndex] = data;
      }
      else {
        this.againData.push(data);
      }

      this.popupAgain = false;
    },

    removeTag(index) {
      this.againData.splice(index, 1);
    },

    editTag(index) {
      this.currentAgainTime = this.againData[index].time;
      this.noteData = this.againData[index].detail;
      this.currentAgainIndex = index;
      this.popupAgain = true;
    },

    async save() {
      this.$toast.loading();

      const modify = [];

      this.againData.forEach((item) => {
        const obj = {
          dot_time: item.time,
          detail: {}
        };

        Object.keys(item.detail).forEach((key) => {
          obj.detail[key] = item.detail[key].id;
        });

        modify.push(obj);
      });

      const { code, msg } = await this.$fetch('/api/musicService/musicmall/applyAgainWork', {
        method: 'post',
        data: {
          orderid: this.id,
          modify: JSON.stringify(modify),
          desc: this.otherNote
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.$toast.success('提交成功');
        this.$router.push(`/order/${this.id}`);
      }
      else {
        this.$toast.fail(msg);
      }
    },

    openHistory() {
      this.popupHistory = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      this.$nextTick(() => {
        this.getHistory();
      });
    },

    closePopupAgain() {
      trackElClickH5('标记备注弹窗-关闭');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/apply-alter.scss";
</style>
